import { ComponentRemoveStore } from "./ComponentRemoveStore";
var removeComponent = function (opts) {
    ComponentRemoveStore.init(opts);
};
export { removeComponent };
